module.exports = __webpack_public_path__ + "img/home_4.04dd3e33.jpg";